angular.module('env.data.httpInterceptors', [

    'env.data.httpInterceptors.authInterceptor',
    'env.data.httpInterceptors.jsonResponseInterceptor',
    'env.data.httpInterceptors.omVersionInterceptor',
    'env.data.httpInterceptors.requestRepeaterInterceptor',

    'env.data.httpInterceptors.xhrTracerInterceptor'
])

    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('jsonResponseInterceptor');
        $httpProvider.interceptors.push('omVersionInterceptor');
        $httpProvider.interceptors.push('requestRepeaterInterceptor');

        //$httpProvider.interceptors.push('xhrTracerInterceptor');
    })

;